module.exports = __webpack_public_path__ + "9920a4278019899ec061705270af4453.svg";